import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { SLIDES } from "./slides";
import { EASE } from "./shared";

export const Overview = ({ open, index, onClose, onSelect }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-[#060B19]/92 p-6 backdrop-blur-xl"
        onClick={onClose}
        data-testid="overview-modal"
      >
        <motion.div
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 24, opacity: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
          className="w-full max-w-4xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mb-6 flex items-center justify-between">
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]">
              Indice del deck
            </span>
            <button
              data-testid="overview-close-button"
              onClick={onClose}
              aria-label="Chiudi indice"
              className="flex h-9 w-9 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-[#D4AF37]"
            >
              <X size={16} />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
            {SLIDES.map((s, i) => (
              <button
                key={s.id}
                data-testid={`overview-item-${s.id}`}
                onClick={() => onSelect(i)}
                className={`group flex flex-col items-start gap-3 border p-4 text-left transition-all duration-300 ${
                  i === index
                    ? "border-[#D4AF37]/70 bg-[#D4AF37]/10"
                    : "border-white/10 bg-white/[0.03] hover:border-[#D4AF37]/40 hover:bg-white/[0.06]"
                }`}
              >
                <span className={`font-mono text-[10px] tracking-[0.25em] ${i === index ? "text-[#D4AF37]" : "text-white/35 group-hover:text-[#D4AF37]/70"}`}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-serif text-lg leading-tight text-[#FAF7F2]">{s.nav}</span>
              </button>
            ))}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
